import styled from "styled-components";

export const V3RecaptchaWrapper = styled.div`
    display: inline-block;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
    min-height: 78px;
`;